import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const ItemTable = (props) => {
    return (
        <div className="itemList-table ">
            <div className="table-container overflow-y-scroll h-[34vh] max-h-[34vh]"
            >
                <table className="itemList ">
                    <thead>
                        <tr>
                            <td className='w-[2%]'>Sr.</td>
                            <td className='w-[16%]'>Item Name</td>
                            <td className='w-[6%]'>Packing</td>
                            <td className='w-[8%]'>Batch No</td>
                            <td className='w-[7%]'>Mfg Date</td>
                            <td className='w-[7%]'>Exp Date</td>
                            <td className='w-[5%]'>M.R.P.</td>
                            <td className='w-[4%]'>Qty.</td>
                            <td className='w-[4%]'>Free</td>
                            <td className='w-[4%]'>Rate</td>
                            <td className='w-[8%]'>Amount</td>
                            <td className='w-[4%]'>Disc.</td>
                            <td className='w-[9%]'>Txbl. Amt</td>
                            <td className='w-[8%]'>HSN Code</td>
                            <td className='w-[8%] !text-center'>Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.itemListing && props.itemListing.length > 0
                            ? props.itemListing.map((item, key) => (

                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.packing}</td>
                                    <td>{item.batchNo ? item.batchNo : '-'}</td>
                                    <td>{item.mfgDate ? moment(item.mfgDate).format('MM-yyyy') : '-'}</td>
                                    <td>{item.expDate ? moment(item.expDate).format('MM-yyyy') : '-'}</td>
                                    <td>{Number(item.mrp).toFixed(2)}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.free}</td>
                                    <td>{Number(item.rate).toFixed(2)}</td>
                                    <td>{Number(item.amount).toFixed(2)}</td>
                                    <td>{Number(item.discAmount).toFixed(2)}</td>
                                    <td>{Number(item.taxableAmount).toFixed(2)}</td>
                                    <td>{item.hsnCodeName}</td>
                                    <td className='!text-center'>

                                        <button
                                            className="search-btn"
                                            onClick={() => props.editItemDetails(key)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {item.isFromDB ?
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemFromDBById(item)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                            :
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemById(key)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>

                                        }
                                    </td>
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
            <button
                className={`add-btn mt-2.5 mb-4 ${props.isHideAddItem ? 'disable-input' : ''}`}
                onClick={() => props.openPopUpForAddingItem()}
            >
                Add Item
            </button>
        </div>
    );
};

export default ItemTable;